export default __webpack_public_path__ + "static/media/bg3.8d4918fc.jpg";